export default [
  {
    title: '输入字段',
    disabled: false,//标记开发中
    list: [
      {
        type: 'input',
        label: '单行文本',
        icon: 'icon-input',
        span: 22,
        display: true,
        fieldId: '',
      },
      {
        type: 'password',
        label: '密码',
        icon: 'icon-password',
        span: 22,
        display: true,
        fieldId: '',
      },
      {
        type: 'textarea',
        label: '多行文本',
        icon: 'icon-textarea',
        span: 22,
        display: true,
        fieldId: '',
      },
      {
        type: 'number',
        label: '数字',
        icon: 'icon-number',
        span: 24,
        controls: true,
        span: 22,
        display: true,
        fieldId: '',
      },
    ],
  },
  {
    title: '选择字段',
    list: [
      {
        type: 'radio',
        label: '单选框组',
        icon: 'icon-radio',
        dicData: [
          { label: '选项一', value: '0' },
          { label: '选项二', value: '1' },
          { label: '选项三', value: '2' },
        ],
        span: 22,
        display: true,
        dicOption: 'static',
        fieldId: '',
      },
      {
        type: 'checkbox',
        label: '多选框组',
        icon: 'icon-checkbox',
        dicData: [
          { label: '选项一', value: '0' },
          { label: '选项二', value: '1' },
          { label: '选项三', value: '2' },
        ],
        span: 22,
        display: true,
        dicOption: 'static',
        fieldId: '',
      },
      {
        type: 'select',
        label: '下拉选择器',
        icon: 'icon-select',
        dicData: [
          { label: '选项一', value: 0 },
          { label: '选项二', value: 1 },
          { label: '选项三', value: 2 },
        ],
        span: 24,
        // 用于做级联配置
        cascaderItem: [],
        span: 22,
        display: true,
        dicOption: 'static',
        fieldId: '',
      },
      {
        type: 'switch',
        label: '开关',
        icon: 'icon-switch',
        span: 22,
        display: true,
        value: 0,
        span: 24,
        dicData: [
          { label: '', value: '0' },
          { label: '', value: '1' },
        ],
        fieldId: '',
      },
      {
        type: 'rate',
        label: '评价',
        icon: 'icon-star',
        span: 22,
        display: true,
        max: 5,
        value: 0,
        span: 24,
        texts: ['极差', '失望', '一般', '满意', '惊喜'],
        colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
        fieldId: '',
      },
      {
        type: 'slider',
        label: '滑块',
        icon: 'icon-slider',
        span: 22,
        display: true,
        span: 24,
        min: 0,
        max: 10,
        fieldId: '',
      },
      {
        type: 'cascader',
        label: '级联选择器',
        icon: 'icon-link',
        span: 22,
        display: true,
        dicData: [
          {
            label: '选项一',
            value: 0,
            children: [
              {
                label: '选项1-1',
                value: 11,
              },
              {
                label: '选项1-2',
                value: 12,
              },
            ],
          },
          { label: '选项二', value: 1 },
          { label: '选项三', value: 2 },
        ],
        cascaderIndex: 1,
        showAllLevels: true,
        dicOption: 'static',
        separator: '/',
        fieldId: '',
      },
    ],
  },
  {
    title: '日期时间字段',
    list: [
      // {
      //   type: 'month',
      //   label: '年月',
      //   icon: 'icon-month',
      //   span: 22,
      //   display: true,
      //   format: 'MM',
      //   valueFormat: 'MM',
      //   fieldId: '',
      // },
      // {
      //   type: 'week',
      //   label: '周',
      //   icon: 'icon-week',
      //   span: 22,
      //   display: true,
      //   format: 'yyyy 第 WW 周',
      // },
      {
        type: 'date',
        label: '日期',
        icon: 'icon-date',
        span: 22,
        display: true,
        format: 'yyyy-MM-dd',
        valueFormat: 'yyyy-MM-dd',
        fieldId: '',
      },
      // {
      //   type: 'time',
      //   label: '时间',
      //   icon: 'icon-time',
      //   span: 22,
      //   display: true,
      //   format: 'HH:mm:ss',
      //   valueFormat: 'HH:mm:ss',
      //   fieldId: '',
      // },
      {
        type: 'datetime',
        label: '日期时间',
        icon: 'icon-datetime',
        span: 22,
        display: true,
        format: 'yyyy-MM-dd HH:mm:ss',
        valueFormat: 'yyyy-MM-dd HH:mm:ss',
        fieldId: '',
      },
      {
        type: 'daterange',
        label: '日期范围',
        icon: 'icon-date-range',
        span: 22,
        display: true,
        format: 'yyyy-MM-dd',
        valueFormat: 'yyyy-MM-dd',
        fieldId: '',
      },
      // {
      //   type: 'timerange',
      //   label: '时间范围',
      //   icon: 'icon-time-range',
      //   span: 22,
      //   display: true,
      //   format: 'HH:mm:ss',
      //   valueFormat: 'HH:mm:ss',
      //   fieldId: '',
      // },
      {
        type: 'datetimerange',
        label: '日期时间范围',
        icon: 'icon-datetime-range',
        span: 22,
        display: true,
        format: 'yyyy-MM-dd HH:mm:ss',
        valueFormat: 'yyyy-MM-dd HH:mm:ss',
        fieldId: '',
      },
    ],
  },
  // {
  //   title: '插件字段（富文本需要单独引入）',
  //   list: [
  //     {
  //       title: '分割线',
  //       type: 'divider',
  //       labelWidth: '40',
  //       prop: 'divider',
  //       component: 'elDivider', //ele分割线
  //       span: 22,
  //       icon: 'icon-map',
  //       params: {
  //         html: '<h3 style="color:red">分割线标题</h3>',
  //         contentPosition: 'left',
  //       },
  //     },
  //     {
  //       title: '日历',
  //       type: 'calendar',
  //       labelWidth: '40',
  //       prop: 'calendar',
  //       icon: 'icon-map',
  //       component: 'elCalendar', //ele日期
  //       span: 22,
  //       params: {},
  //     },
  //     {
  //       type: 'ueditor',
  //       component: 'avue-ueditor',
  //       label: '富文本',
  //       icon: 'icon-richtext',
  //       span: 22,
  //       display: true,
  //       options: {
  //         action: '',
  //         oss: '',
  //         props: {},
  //         ali: {},
  //         qiniu: {},
  //       },
  //     },
  //   ],
  // },
  {
    title: '其他字段',
    list: [
      // {
      //   type: 'color',
      //   label: '颜色选择器',
      //   icon: 'icon-color',
      //   span: 22,
      //   display: true,
      // },
      {
        type: 'upload',
        label: '上传',
        icon: 'icon-upload',
        span: 22,
        display: true,
        showFileList: true,
        multiple: true,
        span: 24,
        limit: 10,
        propsHttp: {},
        canvasOption: {},
        headersConfig: [],
        dataConfig: [],
        fieldId: '',
      },
      {
        type: 'map',
        label: '地图选择器',
        icon: 'icon-map',
        span: 22,
        display: true,
        fieldId: '',
      },
      {
        type: 'qrCode',
        label: '二维码',
        icon: 'icon-color',
        span: 22,
        display: true,
        fieldId: '',
      },
    ],
  },
  {
    title: 'PC端专属',
    list: [
      {
        type: 'richtext',
        label: '富文本',
        icon: 'icon-upload',
        display: true,
        showFileList: true,
        multiple: true,
        limit: 10,
        propsHttp: {},
        canvasOption: {},
        headersConfig: [],
        dataConfig: [],
      }
    ],
  },
  {
    title: '移动端专属',
    list: [
      {
        type: 'qrCode',
        label: '二维码',
        icon: 'icon-color',
        display: true,
      },
      {
        type: 'test',
        label: '测试',
        icon: 'icon-color',
        display: true,
        platform: 'mobile',
        component: 'test'
      }
    ]
  },
];
